import React, { FC } from 'react';
import { Row } from 'react-table';
import { useDispatch, useSelector } from 'react-redux';

import { ITepEntryPass } from 'types/tep';
import { leasesSelector } from 'core/redux/selectors/tep';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';
import { IndeterminateCheckbox } from 'components/organisms/sticky-table/row-select-checkbox';

interface IIndeterminateCheckboxProps {
  row: Row<ITepEntryPass>;
}

export const RowSelectCell: FC<IIndeterminateCheckboxProps> = ({ row }) => {
  const dispatch = useDispatch();

  const { selected } = useSelector(leasesSelector);

  const selectedIds = selected.map(({ id }) => String(id));

  const isChecked = selectedIds.includes(row.id);

  const onChange = () => {
    if (isChecked) {
      const updatedSelected = selected.filter(({ id }) => String(id) !== row.id);

      dispatch(leasesActions.select({ leases: updatedSelected || [] }));
    } else {
      const updatedSelected = [...selected, row.original];

      dispatch(leasesActions.select({ leases: updatedSelected || [] }));
    }
  };

  return (
    <div>
      <IndeterminateCheckbox isChecked={isChecked} rowId={row.id} onChange={onChange} />
    </div>
  );
};
